import React, { Component } from "react";
import { Table, Button, Input, Col, Row, Tooltip, Modal, InputNumber } from "antd";
import axios from "axios";
import "./Pages.css";
import EtiquetasPrintModal from "../relatorios/EtiquetasPrintModal";
import ProdutoFrame from '../components/ProdutoFrame';
import GrupoProdutoFrame from '../components/GrupoProdutoFrame';

const { Column } = Table;

export default class extends Component {
  state = {
    listaRegistros: [],
    posicao: 1,
    carregando: false,

    filtros: {
      buscaProduto: { key: '0' },
      buscaGrupo: { key: '0' },
    }
  };

  componentDidMount() {

  }

  onInputChangePosicao = event => {
    this.setState({ posicao: event });
  }

  onChangeProduto = event => {
    const { filtros } = this.state;
    filtros['buscaProduto'] = event.buscaProduto;
    this.setState(event);
  }

  onChangeGrupoProduto = event => {
    const { filtros } = this.state;
    filtros['buscaGrupo'] = event.buscaGrupo;
    this.setState(event);
  }

  onAddProdutoClick = (event) => {
    if ((!this.state.filtros.buscaProduto) || (this.state.filtros.buscaProduto.key === '0') || (this.state.filtros.buscaProduto.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Produto' });
      return;
    }

    // console.log('onAddProdutoClick: ', this.state.filtros.buscaProduto)

    const listaRegistros = [...this.state.listaRegistros];
    listaRegistros.push({
      idf: String(this.state.filtros.buscaProduto.idf),
      item: String(this.state.filtros.buscaProduto.cod),
      descr: this.state.filtros.buscaProduto.prod_grade ? (this.state.filtros.buscaProduto.descr + ' - ' + this.state.filtros.buscaProduto.ptam_descricao + ' - ' + this.state.filtros.buscaProduto.pcor_descricao) : this.state.filtros.buscaProduto.descr,
      preco: this.state.filtros.buscaProduto.vlrVenda,
      qtde: 1,
    });

    this.setState({
      listaRegistros,
    });
  }


  onAddGrupoClick = (event) => {
    if ((!this.state.filtros.buscaGrupo) || (this.state.filtros.buscaGrupo.key === '0') || (this.state.filtros.buscaGrupo.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Grupo' });
      return;
    }
    this.setState({
      listaRegistros: [],
      carregando: true,
    })

    axios.get('/produtos/lista', {
      params: {
        nome: '',
        grupo: this.state.filtros.buscaGrupo.key,
        controlaEstoque: '',
      }
    }).then(response => {
      const { data } = response;
      const listaRegistros = data.map(regList => {
        return {
          idf: regList.prod_idf,
          item: regList.prod_codigo,
          descr: (regList.prod_grade ? (regList.prod_descricao + ' - ' + regList.ptam_descricao + ' - ' + regList.pcor_descricao) : regList.prod_descricao),
          preco: regList.prod_vlr_venda,
          qtde: 1,
        }
      });
      this.setState({
        listaRegistros,
        carregando: false,
      })
    }).catch(error => {
      console.error(error.response);
      this.setState({
        listaRegistros: [],
        carregando: false,
      })
    })
  }


  renderQtdes = (registro) => {
    return (
      <div>
        <Button type="primary" size="small" onClick={() => this.onQtdeMenosClick(registro)} icon="minus" className="botao-primary" style={{ width: 40 }}/>
        <span style={{ paddingLeft: 10, paddingRight: 10 }}> {registro.qtde} </span>
        <Button type="primary" size="small" onClick={() => this.onQtdeMaisClick(registro)} icon="plus" className="botao-primary" style={{ width: 40 }}/>
      </div>
    );
  };

  onQtdeMaisClick = (registro) => {
    registro.qtde = registro.qtde + 1;
    this.forceUpdate();
  };

  onQtdeMenosClick = (registro) => {
    if (registro.qtde > 1) {
      registro.qtde = registro.qtde - 1;
      this.forceUpdate();
    }
  }


  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------


  render() {
    const { listaRegistros, posicao, carregando } = this.state;
    const { buscaProduto, buscaGrupo } = this.state.filtros;

    // console.log('EtiquetasPage.this.state: ', this.state);

    return (
      <div className="contentRoutesContainer">
        <span className="tituloPage">Impressão de Etiquetas</span>
        <div className="divider-page1" />

        <Row>
          <Col xs={6} style={{ width: 110 }}>
            <EtiquetasPrintModal
              posicao={posicao}
              listaRegistros={listaRegistros}
            />
          </Col>
        </Row>

        <Row style={{ marginTop: 10 }}>
          <Col xs={4} style={{ paddingRight: 20 }}>
            <span style={{ fontSize: 13 }}>Posição da Etiqueta</span>
            <InputNumber
              ref="Input"
              id={posicao}
              value={posicao}
              onChange={this.onInputChangePosicao}
              min={1}
              max={65}
              maxLength={2}
              style={{ width: '100%' }}
            />
          </Col>
          <Col xs={24} sm={8} style={{ paddingRight: 20, marginTop: -4 }}>
            <Col xs={22} style={{ paddingRight: 5 }}>
              <ProdutoFrame
                label="Produto"
                id="buscaProduto"
                value={buscaProduto}
                width={"100%"}
                onChange={this.onChangeProduto}
                controlaEstoque="1"
              // descricaoPrimeiroItem="Produtos"
              />
            </Col>
            <Col xs={2} style={{ marginTop: 23 }}>
              <Tooltip title="Adicionar Produto">
                <Button
                  type="primary"
                  icon="plus"
                  htmlType="button"
                  onClick={() => this.onAddProdutoClick()}
                  className="botao-primary"
                  style={{ width: "100%", height: 32 }}
                />
              </Tooltip>
            </Col>
          </Col>

          <Col xs={24} sm={8} style={{ marginTop: -4 }}>
            <Col xs={22} style={{ paddingRight: 5 }}>
              <GrupoProdutoFrame
                label="Grupo"
                id="buscaGrupo"
                value={buscaGrupo}
                width={"100%"}
                onChange={this.onChangeGrupoProduto}
                descricaoPrimeiroItem="Grupos"
              />
            </Col>
            <Col xs={2} style={{ marginTop: 23 }}>
              <Tooltip title="Adicionar Grupo">
                <Button
                  type="primary"
                  icon="plus"
                  htmlType="button"
                  onClick={() => this.onAddGrupoClick()}
                  className="botao-primary"
                  style={{ width: "100%", height: 32 }}
                />
              </Tooltip>
            </Col>
          </Col>
        </Row>

        {/* <br /> */}

        <Table
          dataSource={listaRegistros}
          pagination={false}
          rowKey={(listaRegistros => listaRegistros.idf)}
        >
          <Column
            key="item"
            dataIndex="item"
            title="Código"
            width={"15%"}
            align="left"
            className="listaCadastro"
          />
          <Column
            key="descr"
            dataIndex="descr"
            title="Descrição"
            width={"55%"}
            align="left"
            className="listaCadastro"
          />
          <Column
            key="qtde"
            title="Qtde Etiquetas"
            render={this.renderQtdes}
            width={"30%"}
            align="center"
            className="listaCadastro"
          />

        </Table>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/EtiquetasPage.js